import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../../../../state/app.state';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { UpdateDocumentNameRequest, UpdateFolderNameRequest } from '../../../../../../core/projects.actions';

@Component({
    selector: 'app-edit-name',
    templateUrl: './edit-name.component.html',
    styleUrls: ['./edit-name.component.scss'],
    standalone: false
})
export class EditNameComponent implements OnInit, OnDestroy {
  heading = '';
  action: any;
  projectId: any;
  rowdata: any;

  form = new FormGroup<any>({
    name: new FormControl({ value: null, disabled: false }),
  });

  private readonly onDestroy = new Subject<void>();

  constructor(
    private store: Store<fromRoot.State>,
    public dialogRef: MatDialogRef<EditNameComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.projectId = data?.projectId;
      this.rowdata = data.data;
      this.form.patchValue({
        name: data?.data?.name,
      });
    }
  }

  ngOnInit() {}

  close(): void {
    this.clear();
    this.dialogRef.close();
  }

  clear(): void {
    this.form.reset();
  }

  save(): void {
    const { name } = this.form.getRawValue();

    if (this.rowdata?.type === 'folder') {
      const payload = {
        projectId: this.projectId,
        folderId: this.rowdata?.id,
        data: {
          name,
        },
      };
      this.store.dispatch(UpdateFolderNameRequest({ payload }));
    } else {
      const payload = {
        projectId: this.projectId,
        documentId: this.rowdata?.id,
        data: {
          name,
        },
      };
      this.store.dispatch(UpdateDocumentNameRequest({ payload }));
    }
  }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }
}
